import { CloseCircleFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";

export default function NoAccessPage({ loading }: { loading?: boolean }) {
  return (
    <div id="no-access-page" className="mx-auto max-w-5xl min-h-screen">
      <div className="flex mt-40 justify-center items-center">
        <p className="bg-red-100 border border-red-200 p-3 flex gap-2 items-center rounded-lg text-gray-600 text-sm">
          <CloseCircleFilled style={{ color: "red", fontSize: 30 }} />
          Page not found. Please click{" "}
          <Link className="text-blue-500 font-bold" to={"/home"}>
            here
          </Link>{" "}
          to go back.
        </p>
      </div>
    </div>
  );
}
